import { render, staticRenderFns } from "./PDPModalLearnMore.vue?vue&type=template&id=66c25a03&scoped=true"
import script from "./PDPModalLearnMore.vue?vue&type=script&lang=js"
export * from "./PDPModalLearnMore.vue?vue&type=script&lang=js"
import style0 from "./PDPModalLearnMore.vue?vue&type=style&index=0&id=66c25a03&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c25a03",
  null
  
)

export default component.exports